import { createFileRoute } from '@tanstack/react-router'

import { PaginaAdesaoFrango } from '@/features/adesao-frango/pagina'

export const Route = createFileRoute('/$perfil/adesao-frango')({
  component: PaginaAdesaoFrango,
})
